import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from '@material-ui/core/Paper';
import _ from "lodash";


export default class ComponentToPrint extends React.Component {
  render() {
    const searchData = this.props.searchData;
    const data = this.props.data || [];

    return (
      <div>
        <h3><center><u>Sub Block Weighment Details Report</u></center></h3>
        <div className="row pl-2 pb-4 pt-4">
          <div className="col"><b>Group: </b> {searchData.group}</div>
          <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
          <div className="col">
            <b>Collection Point: </b>{" "}
            {searchData.division === undefined ? "All Collection Points" : searchData.division}
          </div>
          <div className="col">
            <b>Field: </b>{" "}
            {searchData.field === undefined || searchData.field === "0"
              ? "All Fields"
              : searchData.field}
          </div>
          <div className="col"><b>Date: </b> {searchData.date}</div>
        </div>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center" >Registration No.</TableCell>
                <TableCell align="center" >Employee Name</TableCell>
                <TableCell align="center" >Sub Field Name</TableCell>
                <TableCell align="center" >Total Weight (kg)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, i) => (
                <TableRow key={i}>
                  <TableCell component="th" scope="row" align="left"> {row.registrationNo}</TableCell>
                  <TableCell component="th" scope="row" align="left"> {row.employeeName}</TableCell>
                  <TableCell component="th" scope="row" align="left"> {row.subFieldName || "-"}</TableCell>
                  <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {typeof row.totalWeight === "number" ? row.totalWeight.toFixed(2) : row.totalWeight}</TableCell>
                </TableRow>
              )
              )}
            </TableBody>
            <TableHead>
              <TableRow style={{ backgroundColor: "#d4edda" }}>
                 <TableCell colSpan={3} align="center" style={{ fontWeight: "bold" }}>
                  Total Net Weight:
                </TableCell>
                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>
                  <b>{_.sumBy(data, "totalWeight").toFixed(2)} kg</b></TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </div>
    );

  }
}